var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavetime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.062 30.156h-6.95A1.116 1.116 0 000 31.268V53.55a1.115 1.115 0 001.112 1.112h6.95a3.33 3.33 0 003.336-3.302V33.492a3.356 3.356 0 00-3.336-3.336zM5.694 37.94a1.112 1.112 0 110-2.225 1.112 1.112 0 010 2.225zm56.329 4.87a4.382 4.382 0 00-5.349-2.747l-9.418 2.735a7.175 7.175 0 01-7.172 7.006H29.689a1.112 1.112 0 010-2.224h10.396c6.543-.198 6.56-9.72 0-9.93h-8.04a3.466 3.466 0 01-1.88-.545c-2.693-1.7-6.154-4.374-9.528-4.136h-7.04c.012.156.023.334.023.523V51.36a5.515 5.515 0 01-.122 1.123c.357.023.703.13 1.012.311l8.584 5.004a16.144 16.144 0 0015.056.645l21.616-10.23a4.366 4.366 0 002.257-5.404zM28.91 17.746h-2.18a16.675 16.675 0 0015.523 15.522v-2.18a1.112 1.112 0 012.224 0v2.18a16.675 16.675 0 0015.52-15.523h-2.179a1.112 1.112 0 010-2.224h2.18A16.675 16.675 0 0044.476 0v2.18a1.112 1.112 0 11-2.224 0V0a16.674 16.674 0 00-15.521 15.524h2.18a1.112 1.112 0 010 2.223zm10.519 1.245l2.824-2.824V8.85a1.112 1.112 0 012.224 0v7.784a1.163 1.163 0 01-.322.79l-3.147 3.146a1.117 1.117 0 11-1.58-1.579z",
    fill: "url(#paint0_linear_304_6420)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304_6420",
    x1: 0,
    y1: 30,
    x2: 62.272,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavetime);
export default __webpack_public_path__ + "static/media/Savetime.6ab0ecd076955448fc4b4cdd4055cb43.svg";
export { ForwardRef as ReactComponent };